module.exports = __webpack_public_path__ + "static/media/SX.aa037be9.svg";